import React from 'react';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {Grid} from '@material-ui/core'
import ImgMediaCard from './reviewCard'
import {Garlic} from '../../../assets/images/images';
import Card from './bestSellerCarouselCard'
import './style.scss'

// const responsive = {
//   desktop: {
//     breakpoint: {max: 3000, min: 1024},
//     items: 1,
//     slidesToSlide: 1 // optional, default to 1.
//   },
//   tablet: {
//     breakpoint: {max: 1024, min: 1024},
//     items: 1,
//     slidesToSlide: 5 // optional, default to 1.
//   },
//   mobile: {
//     breakpoint: {max: 464, min: 0},
//     items: 1,
//     slidesToSlide: 1 // optional, default to 1.
//   }
// };

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    paritialVisibilityGutter: 60
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    paritialVisibilityGutter: 50
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30
  }
};

const data = [3, 3, 3, 3, 3, 3, 3, 3, 33,]

function Index(props) {
  return (
    // <div className='best-seller-carousel-container'>
    <div className='best-seller-carousel-container'>
      {/*<h2 className='black-color font-18 mb-0'>Featured Product</h2>*/}
      {/*<p className='desc black-color font-12 text-center mb-10 mt-10 p-0 mb-20'>Lorem ipsum dolor sit amet,*/}
      {/*  consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et<br/> dolore magna aliqua. Ut enim ad minim*/}
      {/*  veniam, quis nostrud exercitation ullamco laboris </p>*/}
      <Carousel
        swipeable={false}
        draggable={false}
        showDots={false}
        // renderButtonGroupOutside={true}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={2800}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={1500}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        // deviceType={this.props.deviceType}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px "
      >
        {props.topProducts.map((item, index) => (
          <Card index={index} key={index} item={item}/>
        ))}
      </Carousel>
    </div>
  );
}

export default Index;
